import { Injectable } from "@angular/core";
import { Actions, Effect, ofType } from "@ngrx/effects";
import { catchError, switchMap } from "rxjs/operators";
import { of } from "rxjs";
import { ETechnicalAssistancesActions, GetTechnicalAssistances, SetTechnicalAssistances, TechnicalAssistancesAPIError } from "@edp-store/actions/technical-assistances.actions";
import { FuncionaService } from "@edp-services/funciona.service";
import { IAssistanceActivities } from "@edp-models/funciona.model";
import moment from "moment";
import { LanguageService } from "@edp-services/language.service";

@Injectable()
export class TechnicalAssistancesEffects {


    @Effect()
    getTechnicalAssistances$ = this.actions$.pipe(
        ofType(ETechnicalAssistancesActions.GetTechnicalAssistances),
        switchMap((action: GetTechnicalAssistances) => {
            return this.funcionaService
                .technicalAssistanceDetails(
                    action.user.partnerNumber,
                    action.contract.AccountNumber,
                    action.funciona)
                .pipe(catchError((error: Error) => of(new TechnicalAssistancesAPIError(error))));
        }),
        switchMap((technicalAssistances: IAssistanceActivities | TechnicalAssistancesAPIError) => {
            if (technicalAssistances instanceof TechnicalAssistancesAPIError || !Object.keys(technicalAssistances).length) {
                return of(technicalAssistances);
            } else {
                technicalAssistances.activities.forEach(tech => {
                    tech.date = moment(tech.date)
                        .locale(this.languageService.getLocale())
                        .format("DD MMM YYYY");
                    tech.value = Math.round(tech.value * (1 + (23 / 100)));
                });
                return of(new SetTechnicalAssistances(technicalAssistances));
            }
        })
    );


    constructor(
        private actions$: Actions,
        private funcionaService: FuncionaService,
        private languageService: LanguageService
    ) {}
}
